import React from "react";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api, { formatRupiah } from "@/lib/api";
import StatusBadge from "@/components/StatusBadge";

export default function Orders() {
  const [orders, setOrders] = useState([]);

  const load = () => api.get("/orders/mine").then((r) => setOrders(r.data));
  useEffect(() => { load(); const t = setInterval(load, 5000); return () => clearInterval(t); }, []);

  return (
    <div className="max-w-6xl mx-auto px-4 md:px-8 py-10" data-testid="orders-page">
      <div className="label-mono text-zinc-500">// MY ORDERS</div>
      <h1 className="font-display text-4xl md:text-5xl font-black uppercase mt-1">Riwayat Pesanan</h1>

      {orders.length === 0 ? (
        <div className="mt-8 border border-black p-12 text-center">
          <p className="font-mono text-sm text-zinc-500">// Belum ada pesanan</p>
          <Link to="/catalog" className="btn-primary inline-block mt-4">Belanja sekarang</Link>
        </div>
      ) : (
        <div className="mt-8 border border-black bg-white">
          <table className="w-full text-sm">
            <thead className="bg-zinc-100 border-b border-black">
              <tr>
                <th className="p-4 text-left label-mono">Order No</th>
                <th className="p-4 text-left label-mono hidden md:table-cell">Tanggal</th>
                <th className="p-4 text-left label-mono">Status</th>
                <th className="p-4 text-right label-mono">Total</th>
                <th className="p-4"></th>
              </tr>
            </thead>
            <tbody>
              {orders.map((o) => (
                <tr key={o.id} className="border-b border-zinc-200 hover:bg-zinc-50" data-testid={`order-row-${o.id}`}>
                  <td className="p-4 font-mono text-xs">{o.order_no}</td>
                  <td className="p-4 font-mono text-xs hidden md:table-cell">{new Date(o.created_at).toLocaleString("en-US")}</td>
                  <td className="p-4"><StatusBadge status={o.status} /></td>
                  <td className="p-4 font-mono text-sm font-bold text-right">{formatRupiah(o.total)}</td>
                  <td className="p-4 text-right">
                    <Link to={`/orders/${o.id}`} className="label-mono text-[#FF6A00]">DETAIL →</Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

